/** Типы для работы с API StorageConfiguration **/

/** Типы конфигураций хранилищ (Flags enum) **/
export enum StorageType {
  /** Неизвестный тип хранилища **/
  Unknown = 0,

  /** Тип хранилища S3 **/
  S3 = 1,

  /** Свое хранилище **/
  Fs = 2,

  /** Encrypted Storage **/
  Encrypted = 4,

  /** Encrypted S3 (S3 | Encrypted) **/
  S3Encrypted = 5,

  /** File Storage Encrypted (Fs | Encrypted) **/
  FsEncrypted = 6
}

/** Статусы хранилищ **/
export enum StorageStatus {
  Available = 0,
  Active = 1,
  Error = 2
}

/** Статус пользовательской задачи (миграции) **/
export enum UserTaskStatus {
  /** Отменена **/
  Canceled = -2,

  /** Ошибка выполнения **/
  Error = -1,

  /** Незадано **/
  Unknown = 0,

  /** Зарегистрирована **/
  Register = 1,

  /** Начата **/
  Start = 2,

  /** Завершена **/
  Done = 3,

  /** Завершена с ошибками **/
  DoneWithErrors = 4
}

/** Настройки S3 хранилища **/
export interface S3ConfigurationSettings {
  Key: string;
  Secret: string;
  SystemName: string;
  Bucket: string;
  Url: string;
}

/** Настройки Fs хранилища **/
export interface FsConfigurationSettings {
  Host: string;
}

/** Данные хранилища **/
export interface IStorageConfiguration {
  Id: number;
  Name: string;
  Status: StorageStatus;
  Type: StorageType;
  S3ConfigurationSettings: S3ConfigurationSettings | null;
  FsConfigurationSettings: FsConfigurationSettings | null;
  IsEnabled: boolean;
  IsDefault: boolean;
  HaveFiles: boolean | null;
}

/** Параметры для создания S3 хранилища **/
export interface CreateS3StorageParams {
  Name: string;
  Type: StorageType.S3;
  S3ConfigurationSettings: S3ConfigurationSettings;
  IsEncrypted: boolean;
  IsEnabled?: boolean;
  IsDefault?: boolean;
}

/** Параметры для создания Fs хранилища **/
export interface CreateFsStorageParams {
  Name: string;
  Type: StorageType.Fs;
  FsConfigurationSettings: FsConfigurationSettings;
  IsEncrypted: boolean;
  IsEnabled?: boolean;
  IsDefault?: boolean;
}

/** Параметры для создания хранилища (S3 или Fs, включая зашифрованные варианты) **/
export type CreateStorageParams = CreateS3StorageParams | CreateFsStorageParams;

/** Параметры для изменения статуса Enabled хранилища **/
export interface SetStorageEnabledParams {
  id: number;
  value: boolean;
}

/** Параметры для удаления хранилища **/
export interface DeleteStorageParams {
  id: number;
}

/** Параметры для миграции данных между хранилищами **/
export interface MigrationParams {
  from: number;
  to: number;
}

/** Параметры для получения статуса миграции **/
export interface GetMigrationStatusParams {
  id: number;
}

/** Статус миграции **/
export interface IMigrationStatus {
  TaskId: number;
  StorageId: number;
  Status: number;
  SuccessCount: number;
  ErrorCount: number;
  FilesWithErrorIds: number[];
  Percent: number;
}

/** Параметры для валидации S3 хранилища **/
export interface ValidateS3StorageParams {
  Name?: string;
  Type: StorageType.S3;
  S3ConfigurationSettings: S3ConfigurationSettings;
  IsEncrypted: boolean;
}

/** Параметры для валидации Fs хранилища **/
export interface ValidateFsStorageParams {
  Name?: string;
  Type: StorageType.Fs;
  FsConfigurationSettings: FsConfigurationSettings;
  IsEncrypted: boolean;
}

/** Параметры для валидации хранилища (S3 или Fs, включая зашифрованные варианты) **/
export type ValidateStorageParams = ValidateS3StorageParams | ValidateFsStorageParams;

/** Детали валидации S3 хранилища **/
export interface IValidationDetails {
  IsSuccess: boolean;
  AuthenticationSuccess: boolean;
  BucketExists: boolean;
  WritePermission: boolean;
  ReadPermission: boolean;
  Errors: string[];
}

/** Результат валидации хранилища **/
export interface IValidationResponse {
  Success: boolean;
  FailedValidation: string[];
  Details: IValidationDetails | null;
}

/** Параметры для обновления S3 хранилища **/
export interface UpdateS3StorageParams {
  id: number;
  Name: string;
  Type: StorageType.S3;
  S3ConfigurationSettings: S3ConfigurationSettings;
  IsEncrypted: boolean;
  IsEnabled?: boolean;
}

/** Параметры для обновления Fs хранилища **/
export interface UpdateFsStorageParams {
  id: number;
  Name: string;
  Type: StorageType.Fs;
  FsConfigurationSettings: FsConfigurationSettings;
  IsEncrypted: boolean;
  IsEnabled?: boolean;
}

/** Параметры для обновления хранилища (S3 или Fs, включая зашифрованные варианты) **/
export type UpdateStorageParams = UpdateS3StorageParams | UpdateFsStorageParams;

/** Параметры для отмены миграции **/
export interface CancelMigrationParams {
  id: number;
}
